import { createSlice } from '@reduxjs/toolkit';
import initialState from './organizationContactsInitialState';
import {
  _setNewOrganizationContactForm,
  _setOrgIdForContactForm,
  _setCntId,
  _setContactKey,
  _setHonorific,
  _setFirstName,
  _setLastName,
  _setSuffix,
  _setTitle,
  _setWorkPhone,
  _setParoleOfficer,
  _setInactive,
  _setAddressCity,
  _setCreateDate,
  _setEditdate,
  _setContactEditedby,
  _setContactCreatedby,
} from './organizationContactsActions';

export const organizationContactsSlice = createSlice({
  name: 'getOrganizationContact',
  initialState,
  reducers: {
    getOrganizationContact: (state, action) => action.payload,
    setNewOrganizationContactForm: _setNewOrganizationContactForm,
    setOrgIdForContactForm: _setOrgIdForContactForm,
    setCntId: _setCntId,
    setContactKey: _setContactKey,
    setHonorific: _setHonorific,
    setFirstName: _setFirstName,
    setLastName: _setLastName,
    setSuffix: _setSuffix,
    setTitle: _setTitle,
    setWorkPhone: _setWorkPhone,
    setParoleOfficer: _setParoleOfficer,
    setInactive: _setInactive,
    setAddressCity: _setAddressCity,
    setCreateDate: _setCreateDate,
    setEditdate: _setEditdate,
    setContactEditedby: _setContactEditedby,
    setContactCreatedby: _setContactCreatedby,
    resetOrganizationContact: () => initialState,
  },
});

export const {
  getOrganizationContact,
  setNewOrganizationContactForm,
  setOrgIdForContactForm,
  setCntId,
  setContactKey,
  setHonorific,
  setFirstName,
  setLastName,
  setSuffix,
  setTitle,
  setWorkPhone,
  setParoleOfficer,
  setInactive,
  setAddressCity,
  setCreateDate,
  setEditdate,
  setContactEditedby,
  setContactCreatedby,
  resetOrganizationContact,
} = organizationContactsSlice.actions;

export default organizationContactsSlice.reducer;
